/* MiraJewelryCo — storefront interactions (navigation, gallery, quantity, cart feedback). No commerce logic lives here. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Sticky header shadow */
  const header = $('[data-mj-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile drawer */
  const drawer = $('[data-mj-drawer]');
  const opener = $('[data-mj-drawer-open]');
  if (drawer && opener) {
    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      opener.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('mj-lock', open);
      if (open) $('.mj-drawer__nav a', drawer)?.focus();
      else opener.focus();
    };
    opener.addEventListener('click', () => setOpen(true));
    $$('[data-mj-drawer-close]', drawer).forEach((el) => el.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });
    window.matchMedia('(min-width: 1181px)').addEventListener('change', (e) => { if (e.matches) setOpen(false); });
  }

  /* Search panel (the icon is a plain link to /search without JS) */
  const searchToggle = $('[data-mj-search-toggle]');
  const searchPanel = $('[data-mj-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      const willOpen = searchPanel.hidden;
      searchPanel.hidden = !willOpen;
      if (willOpen) $('[data-mj-search-input]', searchPanel)?.focus();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !searchPanel.hidden) { searchPanel.hidden = true; searchToggle.focus(); } });
  }

  /* Product gallery */
  $$('[data-mj-gallery]').forEach((gallery) => {
    const slides = $$('[data-mj-slide]', gallery);
    const thumbs = $$('[data-mj-thumb]', gallery);
    const select = (index) => {
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i)));
    const step = (dir) => {
      const current = slides.findIndex((s) => !s.hidden);
      select((current + dir + slides.length) % slides.length);
    };
    $('[data-mj-prev]', gallery)?.addEventListener('click', () => step(-1));
    $('[data-mj-next]', gallery)?.addEventListener('click', () => step(1));
    if (slides.length) select(0);
  });

  /* Quantity steppers */
  $$('[data-mj-qty]').forEach((wrap) => {
    const input = $('input', wrap);
    if (!input) return;
    const min = Number(input.min || 1);
    const change = (delta) => {
      const next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
      if (next === Number(input.value)) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    $('[data-mj-minus]', wrap)?.addEventListener('click', () => change(-1));
    $('[data-mj-plus]', wrap)?.addEventListener('click', () => change(1));
  });

  /* Cart page: quantity change submits the existing cart form (server-side update) */
  const cartForm = $('[data-mj-cart-form]');
  if (cartForm) {
    $$('[data-mj-cart-qty] input', cartForm).forEach((input) => input.addEventListener('change', () => cartForm.requestSubmit()));
  }

  /* Cart drawer (Section Rendering API). Product forms and the necklace configurator keep their own validated add-to-cart. */
  const cdrawer = $('[data-mj-cdrawer]');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.dataset.empty = String(n === 0); });
  const setCartOpen = (open) => {
    if (!cdrawer) return;
    cdrawer.classList.toggle('is-open', open);
    cdrawer.setAttribute('aria-hidden', String(!open));
    document.documentElement.classList.toggle('mj-lock', open);
    if (open) $('.mj-icon-btn[data-mj-cdrawer-close]', cdrawer)?.focus();
  };
  const refreshCart = async () => {
    try {
      const [cart, sections] = await Promise.all([
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()),
        fetch(root + '?sections=mj-cart-drawer').then((r) => r.json()),
      ]);
      setCount(cart.item_count);
      const doc = new DOMParser().parseFromString(sections['mj-cart-drawer'] || '', 'text/html');
      const fresh = $('[data-mj-cdrawer-inner]', doc);
      const target = $('[data-mj-cdrawer-inner]', cdrawer);
      if (fresh && target) target.replaceWith(fresh);
    } catch (e) { /* the count and drawer refresh on next navigation */ }
  };
  if (cdrawer) {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-mj-cart-open]');
      if (opener && !e.metaKey && !e.ctrlKey && !e.shiftKey && !document.body.classList.contains('template-cart')) { e.preventDefault(); setCartOpen(true); return; }
      if (e.target.closest('[data-mj-cdrawer-close]')) { setCartOpen(false); return; }
      const line = e.target.closest('[data-mj-line-qty]');
      if (line) {
        line.disabled = true;
        fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line.dataset.line), quantity: Number(line.dataset.qty) }) })
          .then(refreshCart).catch(refreshCart);
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && cdrawer.classList.contains('is-open')) setCartOpen(false); });
  }
  window.addEventListener('mira:cart-added', async () => {
    await refreshCart();
    if (cdrawer) setCartOpen(true);
  });

  /* The configurator injects its own <h1>; drop the server-rendered SEO heading once it exists to keep a single h1. */
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      const heads = $$('.mira-charm-configurator h1');
      if (heads.length > 1) $$('.mira-charm-configurator h1.mj-sr').forEach((h) => h.remove());
    }, 0);
  });
})();
